import { getV1, postV1, delV1 } from '@/common/utils/ajax'
import { handleCol3, handleWxHeadimg, mapHouseDetail, handleImgSize } from '@/common/utils/map_view_data'
import PublicService from '@/service/public'
import { DEFAULT_PER } from '@/config'

const default_weixin_nfo = {
    name: '',
    headimgurl: 'https://cdn.vip-wifi.com/fangchan/img/house-detail/tabs/weixin-active.png'
}

const getBulletComments = (building_id) => {
    return getV1('bullet_comments', {
        commentable_type: 'Fc::Building',
        commentable_id: building_id,
        page: 1,
        per: 20
    })
}

const handleWeixinArticle = (item, wexin_info = default_weixin_nfo) => {
    item.author = item.author || {
        name: wexin_info.name,
        headimgurl: wexin_info.headimg_url
    }
    return {
        ...item,
        content_body: {
            article_url: item.link,
            image_url: item.image,
            title: item.title
        },
        published_date: item.date
    }
}

const excellentConsultants = (building_id) => getV1('excellent_consultants', {
    building_id
}).then((data) => {
    data.forEach(item => handleWxHeadimg(item, 120))
    return data
})

const getBillboard = (id) => {
    return getV1(`buildings/${id}/billboard_material`)
}

const getBuildings = (options) => {
    return getV1('buildings', {
        per: 10,
        ...options
    })
}

const getBuilding = (id, { house_id, status, share_by_consultant_uid } = {} ) => {
    const params = {}
    if (house_id) {
        params.house_id = house_id
    }
    if (status) {
        params.status = status
    }
    if (share_by_consultant_uid) {
        params.share_by_consultant_uid = share_by_consultant_uid
    }
    return getV1(`buildings/${id}`, params)
        .then(mapHouseDetail)
}

const getFacilityQuantity = (id) => {
    return getV1(`buildings/${id}/around_facilities/quantity`)
}

const likeBuilding = (id, liked) => {
    if (liked) {
        return postV1(`buildings/${id}/like`)
    }
    return delV1(`buildings/${id}/like`)
}

const getImgs = (id, category, options) => {
    return getV1(`buildings/${id}/images`, {
        category,
        ...options
    }).then((data) => {
        const is_layout = category === 'layout'
        const min_w = is_layout ? 670 : 200
        const min_h = is_layout ? 600 : 200
        data.items = data.items.map((url) => {
            return {
                ...url,
                orginal_url: handleImgSize(url.image_url, 1500),
                image_url: handleImgSize(url.image_url, min_w, min_h)
            }
        })
        return data
    })
}

const layoutDetail = (building_id, id) => {
    return getV1(`buildings/${building_id}/images/${id}`)
}

const getAcround = (id, params) => getV1(`buildings/${id}/around_facilities`, {
    ...params,
    per: 20
})

const getAcroundOverview = id => getV1(`buildings/${id}/around_facilities/overview`)

const getWeixinArticle = wexinId => getV1('weixin_articles', {
    page: 1,
    per: DEFAULT_PER,
    weixin_account_id: wexinId
})

const getWeixinArticleDetail = (id) => getV1(`weixin_articles/${id}`).then((data) => {
    return handleWeixinArticle(data)
})

const getFeeds = (id, category) => getV1('building_feeds', {
    building_id: id,
    category
})

const getFeedDetail = (id) => getV1(`building_feeds/${id}`)

const getArticle = (id, wexinId) => {
    return Promise.all([
        getFeeds(id, '自媒体'),
        wexinId ? getWeixinArticle(wexinId) : Promise.resolve([])
    ]).then(([mediaInfo, wexinInfo]) => {
        return {
            media: mediaInfo.items,
            weixin: wexinInfo.items ? wexinInfo.items.map((item) => handleWeixinArticle(item, wexinInfo)) : []
        }
    })
}

const getEvents = (params) => {
    return getV1(`building_events`, params)
}

const getEvent = (id, params) => {
    if (params.category === '全部') {
        delete params.category
    }
    return getV1(`building_events`, {
        building_id: id,
        ...params
    })
}

const createEvent = (id, params) => {
    return postV1(`buildings/${id}/events`, params)
}

const getPredict = house_id => {
    return getV1(`houses/${house_id}/register_predictions`)
}

const housePrice = (house_id, data) => {
    Object.keys(data).forEach((key) => {
        if (!data[key]) {
            delete data[key]
        }
    })
    return getV1(`houses/${house_id}/prices`, data)
}

const getPriceDiagrams = (house_id) => {
    return getV1(`houses/${house_id}/house_price_block_diagrams`)
}

const houseSurplusApartments = (house_id, data) => {
    Object.keys(data).forEach((key) => {
        if (!data[key]) {
            delete data[key]
        }
    })
    return getV1(`houses/${house_id}/surplus_apartments`, data)
}

const getEventsTpl = (building_id) => {
    return getV1(`buildings/${building_id}/events/new`)
}

const getHistoryLottery = (building_id) => {
    return getV1(`buildings/${building_id}/houses`, {
        status: 'history_lottery'
    })
}

const getYouLike = (building_id) => {
    return PublicService.getRecommendation('guess_like', {
        limit: 4,
        building_id
    }).then((you_like_buidings) => {
        const primary_position = you_like_buidings.filter(({ position }) => position === 'primary_guess_like')
        const secondary_position = you_like_buidings.filter(({ position }) => position === 'secondary_guess_like')
        return {
            primary_position: handleCol3(primary_position),
            secondary_position: handleCol3(secondary_position)
        }
    }).catch(console.error)
}

const getPriceDetail = (house_id, price_id) => {
    return getV1(`houses/${house_id}/prices/${price_id}`)
}

const getSurplusPriceDetail = (house_id, price_id) => {
    return getV1(`houses/${house_id}/surplus_apartments/${price_id}`)
}

const getBlockPrices = (house_id, params = {}) => {
    return getV1(`houses/${house_id}/block_mode_house_prices`, params)
}

const getSurplusBlockPrices = (house_id, params = {}) => {
    return getV1(`houses/${house_id}/block_mode_surplus_apartments`, params)
}

const getBuildingRanks = (ranking_type = 'comments', zone) => {
    return getV1(`building_rankings`, {
        ranking_type,
        zone
    })
}

const getCoupons = (building_id, opts) => {
    return getV1('coupons', {
        building_id,
        ...opts
    })
}

const getReceivedCoupons = (opts) => {
    return getV1('received_coupons', opts)
}

const receiveCoupon = (coupon_id) => {
    return postV1('received_coupons', { coupon_id })
}

const getBlocks = (building_id) => {
    return getV1('building_blocks', {
        building_id
    })
}

const getFollowedBuildings = (data) => {
    return getV1('followed_buildings', data)
}

export default {
    getPriceDetail,
    getSurplusPriceDetail,
    getBillboard,
    likeBuilding,
    getImgs,
    getAcround,
    getAcroundOverview,
    getArticle,
    getEvents,
    getEvent,
    createEvent,
    getPredict,
    housePrice,
    getEventsTpl,
    houseSurplusApartments,
    excellentConsultants,
    getHistoryLottery,
    getYouLike,
    getFeedDetail,
    getWeixinArticleDetail,
    getBlockPrices,
    getSurplusBlockPrices,
    getBuildingRanks,
    getBuildings,
    getBuilding,
    getCoupons,
    receiveCoupon,
    getReceivedCoupons,
    getFeeds,
    getBlocks,
    layoutDetail,
    getPriceDiagrams,
    getFacilityQuantity,
    getFollowedBuildings,
    getBulletComments
}
